module.exports = __webpack_public_path__ + "media/images/payment-b0decc057e2454945f846920aa063546.svg";